import './polyfills.ts';

// @ts-ignore
export { default as satisfiesSemverSync } from './satisfiesSemverSync.ts';
